import {
  APPLY_NFC_CARD,
  GET_USER_NFC_CARDS,
  NFC_CARD_ACCOUNT,
  NFC_CARD_ACCOUNT_TOPUP,
  NFC_CARD_PAYMENT,
  UPDATE_NFC_CARD_BANK_DETAILS,
  UPLOAD_NFC_CARD_PHOTO,
} from "../../constants/api_constants";
import { handleApi, handleFileUpload } from "../utils";

export const getUserNfcCards = async () => {
  return handleApi("get", GET_USER_NFC_CARDS);
};

export const applyNfcCard = async (values) => {
  return handleApi("post", APPLY_NFC_CARD, values);
};

export const updateNfcCardBankDetails = async (id, values) => {
  return handleApi(
    "patch",
    `${UPDATE_NFC_CARD_BANK_DETAILS}/${id}/details`,
    values
  );
};

export const uploadNfcCardPhoto = async (id, value) => {
  return handleFileUpload(`${UPLOAD_NFC_CARD_PHOTO}/${id}`, value);
};

export const nfcCardPayment = async (id) => {
  return handleApi("get", `${NFC_CARD_PAYMENT}/${id}`);
};

export const getNfcAccount = async () => {
  return handleApi("get", NFC_CARD_ACCOUNT);
};

export const topupNfcAccount = async (values) => {
  return handleApi("post", NFC_CARD_ACCOUNT_TOPUP, values);
};
